import { Establishment } from '@/types/establishment';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface EstablishmentsState {
	establishments: Establishment[];
	updateEstablishments: (establishments: Establishment[]) => void;
}

const persistConfig = {
	name: 'gurupass-establishments',
};

export const useEstablishmentsStore = create<EstablishmentsState>()(
	persist(
		devtools(set => ({
			establishments: [],
			updateEstablishments: (establishments: Establishment[]) =>
				set({ establishments }),
		})),
		persistConfig
	)
);

if (global.window && (global.window as any).Cypress) {
	const initialState = (global.window as any).initialState;
	if (initialState) {
		useEstablishmentsStore.setState(initialState);
	}
	(window as any).establishmentsStore = useEstablishmentsStore;
}

export default useEstablishmentsStore;
